import React from 'react';
import StepProgress from 'components/StepProgress';

export function StepsPage() {
	return (<StepProgress />) as JSX.Element;
}
